import * as Yup from 'yup';

export const initialValues = {
  code: '',
};

export const validationSchema = Yup.object().shape({
  code: Yup.string()
    .matches(/^\d{6}$/, 'Should be 6 digits')
    .required('Code is required')
});
